// extracted by mini-css-extract-plugin
export default {"content":"ListInvoices_content__IQKwr","detail":"ListInvoices_detail__QBqGg"};